module.exports = __webpack_public_path__ + "static/img/46.aee9c78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/46.png
// module id = B6ya
// module chunks = 0